<mat-chip class="st-beta-label">
    {{ languageSettings().PSTWebBetaLabel }}
</mat-chip>
